import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["handleReload", "height", "width", "tooltipTitle", "loading", "disabled"];

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { useState, useCallback, useEffect, useRef } from 'react';
import { ReloadOutlined } from '@ant-design/icons';
import styled from '@xstyled/styled-components';
import { SecondaryButton } from '../button/secondary-button';
import { Tooltip } from 'antd';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledReloadButton = styled(SecondaryButton)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: ", ";\n  width: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border-radius: 8px;\n  .anticon {\n    font-size: 18px;\n  }\n"])), function (_ref) {
  var height = _ref.height;
  return height ? "".concat(height, "px") : '32px';
}, function (_ref2) {
  var width = _ref2.width;
  return width ? "".concat(width, "px") : 'auto';
});
export var ReloadButton = function ReloadButton(_ref3) {
  var handleReload = _ref3.handleReload,
      _ref3$height = _ref3.height,
      height = _ref3$height === void 0 ? 32 : _ref3$height,
      _ref3$width = _ref3.width,
      width = _ref3$width === void 0 ? 32 : _ref3$width,
      tooltipTitle = _ref3.tooltipTitle,
      loadingProp = _ref3.loading,
      disabled = _ref3.disabled,
      rest = _objectWithoutProperties(_ref3, _excluded);

  var _useState = useState(false),
      localLoading = _useState[0],
      setLocalLoading = _useState[1];

  var mounted = useRef(true);
  var animationTimer = useRef();
  useEffect(function () {
    mounted.current = true;
    return function () {
      mounted.current = false;
      if (animationTimer.current) clearTimeout(animationTimer.current);
    };
  }, []);
  var loading = loadingProp || localLoading;
  var handleClick = useCallback( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLocalLoading(true);
              _context.prev = 1;
              _context.next = 4;
              return handleReload(e);

            case 4:
              _context.prev = 4;
              // Ensure the animation is visible for at least 600ms
              if (mounted.current) animationTimer.current = setTimeout(function () {
                return setLocalLoading(false);
              }, 600);
              return _context.finish(4);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1,, 4, 7]]);
    }));

    return function (_x) {
      return _ref4.apply(this, arguments);
    };
  }(), [handleReload]);

  var button = /*#__PURE__*/_jsx(StyledReloadButton, _objectSpread({
    icon: /*#__PURE__*/_jsx(ReloadOutlined, {
      spin: loading
    }),
    onClick: handleClick,
    height: height,
    width: width,
    disabled: disabled || loading
  }, rest));

  if (tooltipTitle) {
    return /*#__PURE__*/_jsx(Tooltip, {
      title: tooltipTitle,
      children: button
    });
  }

  return button;
};